import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LoanValidation, ValidationRun, ValidationDetail, RunSummary } from '../models/truth-management.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LoanValidationService {
  constructor(private http: HttpClient) { }

  getLoanValidations(): Observable<LoanValidation[]> {
    return of([]);
  }

  getLoanValidationById(id: number): Observable<LoanValidation | undefined> {
    return of(undefined);
  }

  getValidationRunsByLoanId(loanId: number): Observable<ValidationRun[]> {
    return of([]);
  }

  getValidationRunById(runId: string): Observable<ValidationRun | undefined> {
    return of(undefined);
  }

  startNewValidation(loanId: number): Observable<ValidationRun> {
    throw new Error('Use TruthManagement.runEvaluation() instead');
  }

  getValidationDetailsByRunId(runId: string): Observable<ValidationDetail[]> {
    return of([]);
  }

  getRunSummary(runId: string): Observable<RunSummary> {
    return of({
      totalFiles: 0,
      processedFiles: 0,
      matchedFields: 0,
      unmatchedFields: 0,
      overallAccuracy: 0,
      fileCount: 0,
      uniqueAttributes: 0,
      totalAttributes: 0
    });
  }

  filterValidationDetails(runId: string, fileName?: string): Observable<ValidationDetail[]> {
    return of([]);
  }

  getDocumentCountForLoan(loanId: number): Observable<number> {
    return of(0);
  }

  getDocumentCodesForLoan(loanId: number): Observable<string[]> {
    return of([]);
  }
}

